import { isPreEnv } from 'core/constants';
import { getSite } from './sites';

const replaces = () => {
  if (isPreEnv) {
    return 'v1';
  }
  const site = getSite();
  if (site === 'antena3') {
    return 'a3';
  }
  if (site === 'lasexta') {
    return 'l6';
  }
  if (site === 'ondacero') {
    return 'oc';
  }
  if (site === 'ondacero') {
    return 'oc';
  }
  if (site === 'larazon') {
    return 'lr';
  }
  return 'v1';
};
export const places = 'v1/place/search?'.replace('v1', replaces());
export const excludes = 'v1/place/manualUrl/'.replace('v1', replaces());
export const placesElastic = 'v1/place/elastic/'.replace('v1', replaces());
export const nearestTown = 'v1/place/nearesttown?'.replace('v1', replaces());
export const result = 'v1/escrutinio'.replace('v1', replaces());
export const historic = 'v1/election/historic'.replace('v1', replaces());
export const twitter = 'v1/twitter/info'.replace('v1', replaces());
export const politicalParties = 'v1/politicalparty/matchparties'.replace(
  'v1',
  replaces()
);
